import { SocialMediaShareTracking } from './googleAnalytics/socialMediaShareTracking';
import { EmailShareTracking } from './googleAnalytics/emailShareTracking';
import { SharePopoverTracking } from './googleAnalytics/sharePopoverTracking';
import QRCode from 'easyqrcodejs';

$(() => {
    $('[data-toggle="popover"]').popover({
        html : true,
        placement : 'bottom',
        template : '<div class="popover header-links-popover" role="tooltip"><div class="arrow header-links-popover-arrow"></div><div class="popover-body header-links-popover-body"></div></div>', 
        content: function() {
            
          return $('#header-links-social-popover-div').html();
        } 
    });   

    $('[data-toggle="popover"]').on('show.bs.popover', function () {
        $(this).addClass('open');    
    })    

    $('[data-toggle="popover"]').on('hide.bs.popover', function () {
        $(this).removeClass('open');    
    })    

    $('[data-toggle="popover"]').on('shown.bs.popover', function () {
        EmailShareTracking.trackEmailSharing();   
        SocialMediaShareTracking.socialMediaSharing();
        SharePopoverTracking.track();
    })    
	
	$('[data-toggle="popover"]').on('inserted.bs.popover', function () {
		//	QRCODE WECHAT
		$('.header-links-qrcode').each(function(index, elem) {
			new QRCode(elem, {
				text: document.URL,
				width: 164,
				height: 164,
				colorDark: "#000000",
				colorLight: "#ffffff",
				correctLevel: QRCode.CorrectLevel.M
			});
		});	   
    })   

    // TWITTER
    var twitterBtn = $("[data-social-media='twitter']");
    var shareUrl = 'https://twitter.com/intent/tweet?url=' + document.URL + '&text=' + document.title;
    twitterBtn.attr('class','data-social-media-tracking twitter');
    twitterBtn.attr('href', shareUrl);

    // FACEBOOK
    var facebookBtn = $("[data-social-media='facebook']");
    var shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + document.URL + '&quote=' + document.title;
    facebookBtn.attr('class','data-social-media-tracking facebook');
    facebookBtn.attr('href', shareUrl);

    // LINKEDIN
    var linkedinBtn = $("[data-social-media='linkedin']");
    var shareUrl = 'http://www.linkedin.com/shareArticle?mini=true&url=' + document.URL + '&title=' + document.title;
    linkedinBtn.attr('class','data-social-media-tracking linkedin');
    linkedinBtn.attr('href', shareUrl);
    
    // EMAIL
    var emailBtn = $("[data-social-media='email']");
    var shareUrl = 'mailto:?subject=' + document.title + '&body=' + document.URL;
    emailBtn.attr('class','data-social-media-email');
    emailBtn.attr('href', shareUrl);

});